import { postRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const applyForAdRequest = (data) =>
  postRequest(apiEndpoints.applicant.applyForAd, data);
